import React from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import * as accessDenied from "../Login/accessDenied.json";
import * as confirm from "../../assets/lottieAnimation/confirm.json";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GetCookieToken } from "../Cookie/GetCookie";

const ModalExitBeforeTime = ({
  entryOBJ,
  setEntryOBJ,
  handleCloseModalExitBeforeTime,
  outWorkFucn
}) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const navigate = useNavigate();

  const ConfirmExit = async () => {
    await outWorkFucn()
    setEntryOBJ((prev) => ({
      ...prev,
      exitWith: "website",
      isOut: true,
      confirmOut: true,
    }));
    setTimeout(() => {
      navigate("/leave?exitbefore=1");
    }, 2500);
  };

  return (
    <Modal
      size="lg"
      centered
      isOpen={entryOBJ?.exitBeforeTime}
      toggle={handleCloseModalExitBeforeTime}
    >
      <ModalHeader toggle={handleCloseModalExitBeforeTime}>
        ออกงานก่อนเวลา
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xxl={12} className="d-flex justify-content-center">
            {!entryOBJ?.confirmOut ? (
              <h1>คุณต้องการออกงานก่อนเวลาใช่ไหม</h1>
            ) : (
              <FadeIn>
                <h1>กำลังนำท่านไปยังระบบลาออนไลน์</h1>
              </FadeIn>
            )}
          </Col>
          <Col xxl={12} className="d-flex justify-content-center mt-4">
            <div
              className="p-4"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                height: "150px",
                width: "150px",
                border: "5px solid black",
              }}
            >
              <FadeIn>
                {!entryOBJ?.confirmOut ? (
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: accessDenied.default,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    width={180}
                    height={100}
                  />
                ) : (
                  <FadeIn>
                    <Lottie
                      options={{
                        loop: true,
                        autoplay: true,
                        animationData: confirm.default,
                        rendererSettings: {
                          preserveAspectRatio: "xMidYMid slice",
                        },
                      }}
                      width={180}
                      height={180}
                    />
                  </FadeIn>
                )}
              </FadeIn>
            </div>
          </Col>
          <Col className="mt-4" xxl={12}>
            {!entryOBJ?.confirmOut ? (
              <Row>
                <Col xxl={6} className="d-flex justify-content-end">
                  <Button
                    onClick={async () => {
                      ConfirmExit();
                    }}
                    size="lg"
                    color="success"
                  >
                    ตกลง
                  </Button>
                </Col>
                <Col xxl={6} className="d-flex justify-content-start">
                  <Button
                    onClick={handleCloseModalExitBeforeTime}
                    size="lg"
                    color="danger"
                  >
                    ยกเลิก
                  </Button>
                </Col>
              </Row>
            ) : null}
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ModalExitBeforeTime;
